export const formatter = new Intl.NumberFormat("en", {
  style: "currency",
  currency: "USD",
  useGrouping: true,
  notation: "standard",
});
